<div class="pointer-events-none relative h-full w-full">
  <div
    class="absolute left-10 flex h-full w-full flex-col items-center justify-center overflow-hidden"
  >
    <div
      [@moveToTopLeft]="animationState"
      [@moveToCenter]="animationState"
      class="bo-title absolute flex h-96 w-96 items-center justify-center rounded-full p-0 !text-bo-white/60"
      [ngClass]="{ '!hidden': !showAnimation }"
    >
      <div class="pr-10">
        {{ recordingTime() }}
      </div>
    </div>
  </div>
  @if (simulationService.isExerciseStarted()) {
    <div
      class="absolute right-20 flex h-full w-full flex-col items-center justify-center"
    >
      <div class="h-1/2 w-full">
        <ng-lottie
          [options]="{
            path: '/animations/countdown.json',
            loop: false,
          }"
        />
      </div>
    </div>
  }
</div>
